import React, { useEffect, useState } from "react";
import folderpng from "../../assets/images/folder.png";
import Loader from "components/Loader";
import SolarFiles from "components/Modals/Clientpanelpipup/SolarFiles";
import star from "../../assets/images/star.svg";
import useFolderList from "hooks/useFolderList";
import FolderDetail from "components/Modals/FolderDetail";
import notify from "../../assets/images/Notification.png";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const ClientManageFiles = () => {

  const [data, setData] = useState(false);
  const [id, setId] = useState()
  const [dataLength, setDataLength] = useState({
    skip: 0,
    limit: 10
  })
  const [title, setTitle] = useState(false)
  const [loading, setLoading] = useState(false)
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [folderDetails, setFolderDetails] = useState({});

  const handleShow = (id, title) => {
    setShow(true)
    setId(id)
    setTitle(title)
  };
  const { foldersData } = useFolderList(dataLength);


  const handleViewMore = () => {

    const data = dataLength;
    setDataLength({
      ...data,
      limit: data?.limit + 2
    })

  }

  useEffect(() => {
    setData(foldersData);
  }, [foldersData]);

  return (
    <div>
      <div className="container-box">
        <Loader loading={loading} />
        <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2>Manage Files</h2>
          <Nav.Link as={Link} to="/notification" href="/notification">
            <div type="" className=" position-relative">
              <img src={notify} alt="" />
              <span className="position-absolute  badge-custom  rounded-circle">
                <span className="visually-hidden">New alerts</span>
              </span>
            </div>
          </Nav.Link>
        </div>
        <div className="outer-white job-details-page">
          <div className="d-sm-flex folder-row-cards justify-content-md-start justify-content-center  gap-4 flex-sm-wrap">
            {data?.folders?.length > 0 ? (<>
              {data?.folders?.map((item, i) => {
                return <>
                  <div className='folder-outer cursor-pointer' index={i} onClick={() => handleShow(item?._id, item?.title)}>
                    <div className='file_box mb-2'
                    >
                      <img src={folderpng} alt="" />
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>{item?.title}</p>
                      <div className="dropdown">
                        <div
                          className="dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                  <SolarFiles show={show} setShow={setShow} handleClose={handleClose} id={id} setId={setId} title={title} setTitle={setTitle}
                    setShowDetailModal={setShowDetailModal}
                    setFolderDetails={setFolderDetails}
                  />
                </>
              })}
            </>) : (
              <div className="outer-white mission-div w-100 mx-auto">
                <div className="mt-2 ">
                  <div className="disaster-card mx-auto text-center">
                    <div className="alert-distaster mx-auto">
                      <img src={star} alt="" />
                    </div >
                    <h2>No Items Available!</h2>
                  </div >
                </div >
              </div >
            )}
          </div>
          {data?.folders?.length < data?.totalFolders ? (
            <>
              <div className="text-center py-3" style={{ maxWidth: '300px', margin: "auto" }}>
                <button className=" blue-btnnn text-white border-0" onClick={handleViewMore}>
                  View More
                </button>
              </div>
            </>
          ) : null}
        </div>
      </div>
      {showDetailModal && <FolderDetail show={showDetailModal} setShow={setShowDetailModal} folder={folderDetails} setFolder={setFolderDetails} />}
    </div>
  )
}

export default ClientManageFiles
